import React, { useState } from "react";
import InstitutionNavbar from "../components/instituteNavbar";
import Footer from "../components/Footer";
import axios from "axios";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    institutionName: "",
    phone: "9999999999",
    email: "shri@evolvetech.in",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Fetch Institution Name on Mount
  React.useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/profile/getInstProfile`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (res.data && res.data.Institute && res.data.Institute.name) {
            setFormData((prev) => ({
              ...prev,
              institutionName: res.data.Institute.name,
            }));
          }
        }
      } catch (err) {
        console.error("Error fetching institution profile:", err);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact/contact`,
        formData
      );
      setLoading(false);
      setSuccess("Form submitted successfully!");
      alert("Message sent!"); // Alert added
      console.log(response.data);
      // Optional: Clear message only, keep name/phone/email
      setFormData(prev => ({ ...prev, message: "" }));
    } catch (err) {
      setLoading(false);
      setError("Failed to submit contact form.");
      console.error(err);
    }
  };

  return (
    <>
      <InstitutionNavbar />

      <div className="page-container pt-[120px]"> {/* Increased padding */}
        <div
          className="profile-card max-w-[700px] mx-auto"
        >
          <h2 className="page-title text-center">
            Contact Us
          </h2>

          <form onSubmit={handleSubmit}>
            {success && (
              <div className="mb-4 text-green-600">
                {success}
              </div>
            )}
            {error && (
              <div className="error-text mb-4">
                {error}
              </div>
            )}

            <div className="form-group">
              <label className="profile-label">Institution Name</label>
              <input
                type="text"
                name="institutionName"
                value={formData.institutionName}
                onChange={handleChange}
                required
                className="profile-input"
              />
            </div>

            <div className="form-group">
              <label className="profile-label">Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                readOnly
                className="profile-input bg-gray-100 cursor-not-allowed text-gray-500"
              />
            </div>

            <div className="form-group">
              <label className="profile-label">Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                readOnly
                className="profile-input bg-gray-100 cursor-not-allowed text-gray-500"
              />
            </div>

            <div className="form-group">
              <label className="profile-label">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={4}
                className="profile-input"
              ></textarea>
            </div>

            <div className="mt-6 text-center">
              <button
                type="submit"
                disabled={loading}
                className="save-button"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default ContactUs;
